import { makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core";

export const useResizableChartStyle =  makeStyles((theme: Theme)=> ({
  root: {
    width: '100%'
  }
}));
